// Tilastot seinällä: the module's own colours (module-authoring: no imports from other modules).
// Series colours are the dataviz skill's dark-surface categorical palette, in its fixed order.
export const BASE = {
  bg: '#0b0d12',
  panel: '#141922',
  line: '#2c3444',
  text: '#ffffff',
  muted: 'rgba(255,255,255,0.62)',
  grid: 'rgba(255,255,255,0.12)',
  accent: '#c9a7ff',
};
export const SERIES_COLOURS = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'];
